import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

enum PaginatorTranslateKey {
	ItemsPerPage = 'sf.shared_component.paginator.items_per_page',
	NextPage = 'sf.shared_component.paginator.next_page',
	PreviousPage = 'sf.shared_component.paginator.previous_page',
	FirstPage = 'sf.shared_component.paginator.first_page',
	LastPage = 'sf.shared_component.paginator.last_page',
}

@Injectable()
export class MatPaginatorTranslateService extends MatPaginatorIntl {
	constructor(private translateService: TranslateService) {
		super();
		this.translateService.onLangChange.subscribe(() => this.resolveTranslations());
		this.resolveTranslations();
	}

	public getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0 || pageSize === 0) {
			return `0 / ${length}`;
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		return `${startIndex + 1} - ${endIndex} / ${length}`;
	};

	private resolveTranslations(): void {
		this.translateService
			.get([
				PaginatorTranslateKey.ItemsPerPage,
				PaginatorTranslateKey.NextPage,
				PaginatorTranslateKey.PreviousPage,
				PaginatorTranslateKey.LastPage,
				PaginatorTranslateKey.FirstPage,
			])
			.subscribe((translation: any) => {
				this.itemsPerPageLabel = translation[PaginatorTranslateKey.ItemsPerPage];
				this.nextPageLabel = translation[PaginatorTranslateKey.NextPage];
				this.previousPageLabel = translation[PaginatorTranslateKey.PreviousPage];
				this.firstPageLabel = translation[PaginatorTranslateKey.FirstPage];
				this.lastPageLabel = translation[PaginatorTranslateKey.LastPage];
				this.changes.next();
			});
	}
}
